import api from './api'

export interface User {
  id: number
  email: string
  role: 'admin' | 'redacteur'
  first_name: string
  last_name: string
}

class AuthService {
  async login(email: string, password: string): Promise<User> {
    const data = await api.post<{ user: User }>('/auth/login', { email, password })
    return data.user
  }

  async logout(): Promise<void> {
    await api.post('/auth/logout', {})
  }

  async checkAuth(): Promise<User> {
    const data = await api.get<{ user: User }>('/auth/check')
    return data.user
  }
}

export const authService = new AuthService()
